import CallMeModal from '../CallMeModal/CallMeModal';
import { useHippoText } from '../../hooks/useHippoText';
import ViewInformationModal from '../ViewInformationModal/ViewInformationModal';
import type { CustomerStopCause } from 'gw-edge-client/dist/types/dto/pc/typekey';

const CustomerStopModal = ({
    stopCause,
    showModal,
    closeModal
}: {
    stopCause: CustomerStopCause;
    showModal: boolean;
    closeModal: () => void;
}): React.JSX.Element => {
    const getHippoText = useHippoText();

    return (
        <>
            {stopCause === 'Bornholm' && (
                <ViewInformationModal
                    modalProps={{
                        title: getHippoText('DSS-CALL-ME-MODAL-ADDRESS-BORNHOLM-TITLE'),
                        description: getHippoText('DSS-CALL-ME-MODAL-ADDRESS-BORNHOLM-SUBTITLE'),
                        secondDescription: ''
                    }}
                    showModal={showModal}
                    closeModal={closeModal}
                />
            )}
            {stopCause === 'Other' && (
                <CallMeModal
                    activityCode="dss_call_request"
                    title={getHippoText('DSS-CALL-ME-MODAL-NO-PRICE-HEADER')}
                    description={getHippoText('DSS-CALL-ME-MODAL-NO-PRICE-SUBHEADER')}
                    subdescription={getHippoText('DSS-CALL-ME-MODAL-NO-PRICE-BOOK-CALL-SUBHEADER')}
                    showModal={showModal}
                    closeModal={closeModal}
                />
            )}
            {stopCause === 'TotalCustomerRequirement' && (
                <CallMeModal
                    activityCode="dss_call_request"
                    title={getHippoText('DSS-CALL-ME-MODAL-MVP-BVR-71-HEADER')}
                    description={getHippoText('DSS-CALL-ME-MODAL-MVP-BVR-71-SUBHEADER')}
                    subdescription={getHippoText('DSS-CALL-ME-MODAL-MVP-BVR-71-SUBDESCRIPTION')}
                    showModal={showModal}
                    closeModal={closeModal}
                />
            )}
        </>
    );
};

export default CustomerStopModal;
